import { render } from "./LobbyView.vue?vue&type=template&id=cbfa37ac&scoped=true"
import script from "./LobbyView.vue?vue&type=script&lang=js"
export * from "./LobbyView.vue?vue&type=script&lang=js"

import "./LobbyView.vue?vue&type=style&index=0&id=cbfa37ac&scoped=true&lang=css"

import exportComponent from "/var/www/html/jeju43-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbfa37ac"]])

export default __exports__